import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { WhatsAppButton } from './components/UI';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Destinations from './pages/Destinations';
import Migration from './pages/Migration';
import Scholarships from './pages/Scholarships';
import Insurance from './pages/Insurance';
import Stories from './pages/Stories';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import ValueAdded from './pages/ValueAdded';
import Team from './pages/Team';

export default function App() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [page]);

  const pages = {
    home: <Home setPage={setPage} />,
    about: <About setPage={setPage} />,
    services: <Services setPage={setPage} />,
    destinations: <Destinations setPage={setPage} />,
    migration: <Migration setPage={setPage} />,
    scholarships: <Scholarships setPage={setPage} />,
    insurance: <Insurance setPage={setPage} />,
    stories: <Stories setPage={setPage} />,
    faq: <FAQ setPage={setPage} />,
    contact: <Contact setPage={setPage} />,
    'value-added': <ValueAdded setPage={setPage} />,
    team: <Team setPage={setPage} />,
  };

  return (
    <div className="min-h-screen flex flex-col font-body">
      <Navbar currentPage={page} setPage={setPage} />
      <main className="flex-1 pt-[72px]">
        <div key={page} className="animate-fade-up">{pages[page] || pages.home}</div>
      </main>
      <Footer setPage={setPage} />
      <WhatsAppButton />
    </div>
  );
}
